import { isCVReview } from './product.model';
import {
	CVReview_1004,
	CVReview_1073,
	CVReview_1075,
	CVReview_2055,
	InspectionReport,
	SimplifiedLeftMenuItems
} from './intelligence/index';
import { GENERAL_SCHEMA } from './schema-nav';
import { SCHEMA_CONFIG, SIMPLIFIED_NAV_SCHEMA_SET } from './schema-config';

export class NavUtils {
	/**
	 * build navigation depends on schema
	 * @param schema
	 * @param isCMPForm
	 */
	static getSchemaNav(schema: string, isCMPForm: boolean = false): any {
		let schemaName: any = false;
		let items: any = [];

		switch (schema) {
			case SCHEMA_CONFIG.CVReview_1004.schema:
				schemaName = SCHEMA_CONFIG.CVReview_1004.schema;
				items = CVReview_1004;
				break;

			case SCHEMA_CONFIG.CVReview_1073.schema:
				schemaName = SCHEMA_CONFIG.CVReview_1073.schema;
				items = CVReview_1073;
				break;

			case SCHEMA_CONFIG.CVReview_1075.schema:
				schemaName = SCHEMA_CONFIG.CVReview_1075.schema;
				items = CVReview_1075;
				break;

			case SCHEMA_CONFIG.CVReview_2055.schema:
				schemaName = SCHEMA_CONFIG.CVReview_2055.schema;
				items = CVReview_2055;
				break;

			case SCHEMA_CONFIG.InspectionReport.schema:
				schemaName = SCHEMA_CONFIG.InspectionReport.schema;
				items = InspectionReport;
				break;
		}
		// Or if is CMP Form true, render like this as well
		if (isCMPForm || SIMPLIFIED_NAV_SCHEMA_SET.has(schema)) {
			items = SimplifiedLeftMenuItems;
		  	// All AltVal products start with CVReview plus isCMPForm
			if ((!schemaName && isCVReview(schema)) || SIMPLIFIED_NAV_SCHEMA_SET.has(schema)) {
			  schemaName = schema;
			}
		  }
		if (schemaName && items.length > 0) {
			return NavUtils.navBuild(items, schemaName);
		}
	}

	/**
	 * filter the product items and edit nav base on schema
	 * @param items
	 * @param schema
	 */
	static navBuild(items: Array<any>, schema: string): Array<any> {
		const nav = GENERAL_SCHEMA.filter(s => items.includes(s.path));
		return nav.map(n => {
			return { ...n, schema };
		});
	}
}
